export default {
  // Navigation
  about: "소개",
  skills: "기술",
  services: "서비스",
  portfolio: "포트폴리오",
  contact: "연락처",

  // Header
  title: "BRAIN PLAY",
  subtitle: "소프트웨어 · 하드웨어 · 엔지니어링 컨설팅",

  // About
  aboutTitle: "소개",
  name: "심경섭",
  role: "풀스택 소프트웨어 & 하드웨어 엔지니어",
  bio: "웹 서비스, 백엔드 시스템, 임베디드 하드웨어, 자동화, 센서 통합 및 맞춤형 엔지니어링 솔루션을 전문으로 하는 개발자입니다. 소규모 MVP부터 복잡한 엔터프라이즈급 시스템까지 경험이 풍부합니다.",

  // Skills
  skillsTitle: "기술 스택",
  webFrontend: "웹 프론트엔드",
  backend: "백엔드",
  programming: "프로그래밍",
  embedded: "임베디드 / 하드웨어",
  systems: "시스템 & 자동화",
  platforms: "플랫폼",
  general: "일반",

  // Services
  servicesTitle: "서비스",
  webDev: "웹 개발 (프론트엔드 & 백엔드)",
  apiServer: "API 및 서버 아키텍처",
  embeddedDesign: "임베디드 시스템 설계",
  sensorIntegration: "맞춤형 컨트롤러 / 센서 통합",
  prototyping: "전자 프로토타이핑 & 하드웨어 컨설팅",
  automation: "자동화 & 네트워크 시스템 설계",
  consulting: "종합 엔지니어링 컨설팅",

  // Portfolio
  portfolioTitle: "포트폴리오",
  webDashboards: "웹 대시보드",
  iotControllers: "IoT 컨트롤러",
  automationModules: "자동화 모듈/시스템",
  sensorSystems: "센서 기반 임베디드 시스템",
  hardwarePrototypes: "맞춤형 하드웨어 프로토타입",

  // Contact
  contactTitle: "연락처",
  phone: "전화",
  email: "이메일",
  website: "웹사이트",
  contactForm: "연락 양식",
  nameField: "이름",
  emailField: "이메일",
  messageField: "메시지",
  sendMessage: "메시지 보내기",

  // Language
  language: "언어",
  korean: "한국어",
  english: "English"
};